/** Build identity and cache hygiene helpers. */
declare const __BUILD_ID__: string
declare const __APP_VERSION__: string
declare const __RELEASE_ID__: string
declare const __SOFTWARE_REGISTRATION__: Record<string, SoftwareRegistration>
declare const __VERSION_COMPATIBILITY__: Record<string, string>
export interface SoftwareRegistration { name: string; version: string }
export const BUILD_ID = typeof __BUILD_ID__ === 'string' && __BUILD_ID__ ? __BUILD_ID__ : 'dev'
export const APP_VERSION = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'unknown'
// Public UI label; release dates and build identities remain available for diagnostics.
export const DISPLAY_VERSION = 'V2.0'
export const RELEASE_ID = typeof __RELEASE_ID__ === 'string' ? __RELEASE_ID__ : ''
export const SOFTWARE_REGISTRATION: Readonly<Record<string, SoftwareRegistration>> =
  typeof __SOFTWARE_REGISTRATION__ === 'object'
    ? Object.freeze({ ...__SOFTWARE_REGISTRATION__ })
    : Object.freeze({})
export const VERSION_COMPATIBILITY: Readonly<Record<string, string>> = typeof __VERSION_COMPATIBILITY__ === 'object'
  ? Object.freeze({ ...__VERSION_COMPATIBILITY__ })
  : Object.freeze({})
export const FRONTEND_STATE_SCHEMA = VERSION_COMPATIBILITY.frontend_state_schema || 'unknown'

export function softwareVersion(product: string): string {
  return SOFTWARE_REGISTRATION[product] ? DISPLAY_VERSION : '未知版本'
}

export function versionedStorageKey(key: string): string {
  return 'zhilin:' + BUILD_ID + ':' + FRONTEND_STATE_SCHEMA + ':' + key
}

export function clearLegacyFrontendState(): void {
  try {
    const prefixes = ['geometry-cognitive-autosave', 'classroom_offline_answers', 'vlm_draft', 'grading_draft_recovery']
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i) || ''
      if (prefixes.some(prefix => key === prefix || key.startsWith(prefix + ':'))) localStorage.removeItem(key)
    }
  } catch { /* storage may be unavailable */ }
}
